// extracted by mini-css-extract-plugin
export default {"root":"profile-summary_root__S5AzY","avatar":"profile-summary_avatar__7T5n+","avatarBig":"profile-summary_avatarBig__SDVTP"};